import React, { useEffect, useState } from "react";
import AdminHead from "./AdminHead";
import Loading from "../Components/Loading";
import { db } from "../Components/Firebase";
import { doc, getDoc, collection, query, where, getCountFromServer } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import '../Styles/Admin/ViewSapak.css';

function ViewSapak() {
  const { SUID, UID } = useParams();
  const [sapakData, setSapakData] = useState(null);
  const [ordersCount, setOrdersCount] = useState(0);
  const [documentsCount, setDocumentsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const nav = useNavigate()

 useEffect(() => {
  const fetchSapakData = async () => {
    try {
      const sapakRef = doc(db, "Users", SUID);
      const sapakDoc = await getDoc(sapakRef);

      if (sapakDoc.exists()) {
        setSapakData(sapakDoc.data());
      } else {
        setError("הספק לא נמצא.");
      }

      // Count orders
      const ordersQuery = query(collection(db, "Orders"), where("SapakId", "==", SUID));
      const ordersSnapshot = await getCountFromServer(ordersQuery);
      setOrdersCount(ordersSnapshot.data().count);

      // Count documents from "Docs" collection where SUID matches
      const docsQuery = query(collection(db, "Docs"), where("SUID", "==", SUID));
      const docsSnapshot = await getCountFromServer(docsQuery);
      setDocumentsCount(docsSnapshot.data().count);

    } catch (err) {
      console.error(err);
      setError("אירעה שגיאה בהבאת הנתונים.");
    } finally {
      setLoading(false);
    }
  };

  fetchSapakData();
}, [SUID]);


  if (loading) return <Loading />;
  if (error) return <p>{error}</p>;

  return (
    <React.Fragment>
      <AdminHead />
      {sapakData && (
        <div className="sapak-details" dir="rtl">
          <h2>פרטי סוכן</h2>
          <p><strong>שם:</strong> {sapakData.Name || "לא צויין"}</p>
          <p><strong>אימייל:</strong> {sapakData.Email || "לא צויין"}</p>
          <p><strong>תעודת זהות:</strong> {sapakData.IdNumber || "לא צויין"}</p>
          <p><strong>טלפון:</strong> {sapakData.PhoneNumber || "לא צויין"}</p>
          <p><strong>שם העסק:</strong> {sapakData.BName || "לא צויין"}</p>
          <p><strong>מספר חברה:</strong> {sapakData.CompanyNumber || "לא צויין"}</p>
          <p><strong>כתובת:</strong> {sapakData.Location || "לא צויין"}</p>
          <p><strong>מיקוד:</strong> {sapakData.PostalCode || "לא צויין"}</p>
        </div>
      )}

      <div className="SapakFunctions" dir="rtl">
        <div className="Card">
          <h1>הזמנות</h1>
          <h2>מספר הזמנות: {ordersCount}</h2>
          <button onClick={() => {nav(`/AdminHome/${UID}/ViewSapakim/${SUID}/ViewSapakOrders`)}}>הצג הכל</button>
        </div>

        <div className="Card">
          <h1>מסמכים</h1>
          <h2>מספר מסמכים: {documentsCount}</h2>
          <button onClick={() => {nav(`/AdminHome/${UID}/Docs/${SUID}`)}}>הצג הכל</button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ViewSapak;
